import { Button } from "@shared/ui/Button";

export type Props = {
  onClick: () => void;
  className?: string;
};

export function SupportSidebarSupportButton({ onClick, className }: Props) {
  return (
    <Button
      onClick={onClick}
      className={className}
      variant="secondary"
      data-testid="support-sidebar-open-ticket-modal"
    >
      Get Help
    </Button>
  );
}

export default SupportSidebarSupportButton;
